import React from 'react';
import SEO from './SEO';

const divStyle = {
  width: '1000px',
  margin: '0 auto',
};

const AppPolicy = () => {
  return (
    <>
      <div className="privacy-policy" style={divStyle}>
        <br/>
        <h2>Privacy Policy for Insight</h2>
        <i >Last updated: June 25, 2025</i>
        <br/><br/><br/>
        Insight (“we”, “us”, or “our”) is operated by Insight for Innovation. This Privacy Policy explains how we collect, use, share, and protect your personal information when you use our volunteer-student management application (“Insight” or “the App”).

        <br/><br/>
        <h3>1. Information We Collect</h3>
        <p>We collect the following types of personal information from users (volunteers, coordinators, students):</p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Address</li>
          <li>Sexual orientation</li>
          <li>User ID</li>
          <li>Profile photo</li>
          <li>School/college details</li>
          <li>District and state information</li>
          <li>Attendance records, marks, classes, and remarks related to students</li>
        </ul>
        <p>We do <strong>not</strong> collect financial, health, or biometric data.</p>

        <br/><br/>
        <h3>2. How We Use Your Information</h3>
        <p>We use your information to:</p>
        <ul>
          <li>Register and manage volunteers, students, and coordinators</li>
          <li>Record and display student marks, attendance, and progress</li>
          <li>Enable coordinators to oversee activities and performance</li>
          <li>Generate reports and dashboards for evaluation</li>
          <li>Communicate important updates or notifications</li>
          <li>Maintain and update user profiles</li>
        </ul>

        <br/><br/>
        <h3>3. Data Sharing and Disclosure</h3>
        <p>We do <strong>not</strong> sell or share your personal information with third parties for marketing purposes. Information may be shared:</p>
        <ul>
          <li>With authorized coordinators and administrators within Insight for Innovation for management and reporting</li>
          <li>With service providers who assist in hosting, maintaining, or securing the App (subject to confidentiality agreements)</li>
          <li>When required by law, regulation, or legal process</li>
        </ul>

        <br/><br/>
        <h3>4. Data Storage and Security</h3>
        <ul>
          <li>Data is stored securely on cloud servers.</li>
          <li>We use industry-standard security measures, including encryption and access controls, to protect your information.</li>
          <li>Only authorized personnel have access to personal data.</li>
        </ul>

        <br/><br/>
        <h3>5. User Rights and Choices</h3>
        <p>You may have the right to:</p>
        <ul>
          <li>Access, correct, or update your personal information</li>
          <li>Request deletion of your account or data</li>
          <li>Object to or restrict certain data processing activities</li>
        </ul>
        <p>
          To exercise these rights, please contact us at{' '}
          <a href="mailto:insightapp343@gmail.com">insightapp343@gmail.com</a>.
        </p>

        <br/><br/>
        <h3>6. Children’s Privacy</h3>
        <p>
          Our App is intended for use by college students (volunteers) and coordinators. If student data includes information about children under 13, we comply with applicable laws and require parental consent where necessary. We do not knowingly collect personal information directly from children under 13 without appropriate consent.
        </p>

        <br/><br/>
        <h3>7. Policy Updates</h3>
        <p>
          We may update this Privacy Policy from time to time. Users will be notified of significant changes via email, in-app notification, or an announcement on our website. The date of the latest update will always be posted at the top of this policy.
        </p>

        <br/><br/>
        <h3>8. Contact Us</h3>
        <p>
          If you have any questions, concerns, or requests regarding your privacy or this policy, please contact:
        </p>
        <p>
          <strong>Insight for Innovation</strong><br />
          Kadiyapattanam Road, Manacaud, Trivandrum, India<br />
          Email: <a href="mailto:insightapp343@gmail.com">insightapp343@gmail.com</a><br />
          Phone: +91 7356256446
        </p>

        <br/><br/>
        <h3>9. Third-Party Services</h3>
        <p>
          We do not use third-party analytics services or share your personal information with any external parties. All data is managed and stored securely on our own self-hosted backend servers, which are maintained by our team using reputable cloud providers. No user data is shared with or accessible to any third-party service providers.
        </p>

        <br/><br/>
        <h3>10. Legal Compliance</h3>
        <p>
          We comply with all relevant data protection laws, including but not limited to the General Data Protection Regulation (GDPR), the Indian IT Act, and Google Play’s User Data Policy.
        </p>

        <p>
          By using Insight, you acknowledge that you have read and understood this Privacy Policy.
        </p>
      </div>
    </>
  );
};

export default AppPolicy;
